/* eslint-disable no-console */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../App/globalState';

const isValidPath = (path) =>
  typeof path === 'string' && path.trim().length > 0 && path.startsWith('/');

const isValidRequest = (logoutRequest) => {
  if (!logoutRequest) {
    console.error('logoutRequest parameter is missing in logout function');

    return false;
  }
  if (typeof logoutRequest !== 'function') {
    console.error('logoutRequest must be a function');

    return false;
  }

  return true;
};

const isValidGlobalStateKey = (globalStateKey) => {
  if (!globalStateKey) {
    console.error('globalStateKey parameter is missing in logout function');

    return false;
  }
  if (typeof globalStateKey !== 'string') {
    console.error('globalStateKey must be a string');

    return false;
  }

  return true;
};

export default function useLogout() {
  const { globalState, updateGlobalState } = useGlobalState();
  const navigate = useNavigate();

  const logout = useCallback(
    ({ redirectPath, logoutRequest, globalStateKey }) => {
      if (!isValidRequest(logoutRequest) || !isValidGlobalStateKey(globalStateKey))
        return;

      logoutRequest();

      if (Object.keys(globalState[globalStateKey] || {}).length > 0) {
        updateGlobalState({ [globalStateKey]: {} });

        if (redirectPath && isValidPath(redirectPath)) {
          navigate(redirectPath);
        }
      }
    },
    [globalState, updateGlobalState, navigate]
  );

  return logout;
}
